import { useState } from "react";
import OngoingOrderList from "./OngoingOrderList";

const ScannedOrders = ({ count, status, branchId }) => {
  const [isBusy, setIsBusy] = useState(false);
  const showOrders = () => {
    if (count > 0) {
      setIsBusy(true);
    }
  };
  return (
    <>
      <button
        type="button"
        onClick={showOrders}
        className={`btn btn-sm ${
          count > 0 ? "bg-info text-white" : "bg-light text-light"
        }`}
        disabled={isBusy}
      >
        {isBusy === true ? (
          <span
            className="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
        ) : (
          count
        )}
      </button>
      <OngoingOrderList
        isBusy={isBusy}
        setIsBusy={setIsBusy}
        status={status}
        branchId={branchId}
      />
    </>
  );
};

export default ScannedOrders;
